export default __webpack_public_path__ + "static/media/azracan1.84e413ef.jpg";